import * as types from './constants';

export const getProductsList = (query = {}, filter = {}) => ({
    types: [
        types.GET_PRODUCTS_LIST_REQUEST,
        types.GET_PRODUCTS_LIST_SUCCESS,
        types.GET_PRODUCTS_LIST_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/products?` + Object.entries(query).map(([key, val]) => `${key}=${val}`).join('&'),
            method: 'GET',
        }),
});

export const getProductDetails = (productId) => ({
    types: [
        types.GET_PRODUCTS_DETAILS_REQUEST,
        types.GET_PRODUCTS_DETAILS_SUCCESS,
        types.GET_PRODUCTS_DETAILS_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/products/${productId}`,
            method: 'GET',
        }),
});

export const getProductVariationDetails = (variationId) => ({
    types: [
        types.GET_PRODUCT_VARIATIONS_DETAILS_REQUEST,
        types.GET_PRODUCT_VARIATIONS_DETAILS_SUCCESS,
        types.GET_PRODUCT_VARIATIONS_DETAILS_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/product-variations/${variationId}`,
            method: 'GET',
        }),
});

export const updateProductGroup = (productId, data) => ({
    types: [
        types.UPDATE_PRODUCTS_DETAILS_REQUEST,
        types.UPDATE_PRODUCTS_DETAILS_SUCCESS,
        types.UPDATE_PRODUCTS_DETAILS_FAILURE,
    ],
    promise: api =>
        api({
            url: productId ? `/api/v1/products-table/row/${productId}` : '/api/v1/products-table/row',
            method: 'POST',
            body: data
        }),
});

export const getProductByBarcode = (barcode) => ({
    types: [
        types.GET_PRODUCT_BY_BARCODE_REQUEST,
        types.GET_PRODUCT_BY_BARCODE_SUCCESS,
        types.GET_PRODUCT_BY_BARCODE_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/products/barcode?barcode=${barcode}`,
            method: 'GET',
        }),
});

export const massEditUpdateSupplier = (supplier_id, products) => ({
    types: [
        types.MASS_EDIT_SET_SUPPLIER_REQUEST,
        types.MASS_EDIT_SET_SUPPLIER_SUCCESS,
        types.MASS_EDIT_SET_SUPPLIER_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/products/mass-edit/supplier/${supplier_id}`,
            method: 'post',
            body: {
                products
            }
        }),
});

export const massEditUpdateStatus = (enabled, products) => ({
    types: [
        types.MASS_EDIT_CHANGE_STATUS_REQUEST,
        types.MASS_EDIT_CHANGE_STATUS_SUCCESS,
        types.MASS_EDIT_CHANGE_STATUS_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/products/mass-edit/status`,
            method: 'post',
            body: {
                status: enabled,
                products
            }
        }),
});

export const getPriceGroups = () => ({
    types: [
        types.GET_PRICE_GROUPS_REQUEST,
        types.GET_PRICE_GROUPS_SUCCESS,
        types.GET_PRICE_GROUPS_FAILURE,
    ],
promise: api =>
        api({
            url: `/api/v1/product-price-group`,
            method: 'GET',
        }),
})
